import React, { useMemo } from "react";
import { useSelector } from "react-redux";
// import { useLocation } from "react-router";
// import { isString } from "lodash";
import Logo from "../Images/logo.png";
import RLLogo from "../Images/RL-white-logo.webp";
import CahaLogo from "../Images/caha-white-logo.png";
import SkipTheQLogo from "../Images/skiptheq-white-logo.png";
import LocalPubPassportLogo from "../Images/localpubpassport-white-logo.png";
import SkipTheQPassportLogo from "../Images/skiptheqpassport-white-logo.png";
import CharlieCafeLogo from "../Images/charlie-cafe-logo.png";
import { checkMultiStore } from "./utils";
import { useThemeColor } from "../hooks/useThemeColor";
// import { useLocation } from "react-router";

const isSpeedBooking = true;

const Header = (props) => {
  // const location = useLocation();
  const { themeColor } = useThemeColor();
  const { endpoint, store } = useSelector((state) => state.auth);
  const isMultiStore = useMemo(() => checkMultiStore(endpoint), [endpoint]);
  // const isBooking = useMemo(
  //   () => isString(location?.pathname) && location?.pathname?.includes("store"),
  //   [location?.pathname]
  // );
  // console.log("themeColor >> ", themeColor);
  const dStyle = useMemo(
    () => (isMultiStore ? { backgroundColor: themeColor } : {backgroundColor: themeColor}),
    [isMultiStore, themeColor]
  );

  const headerImage = useMemo(() => {
    if (isMultiStore) {
      if (endpoint === "romeolane") {
        return RLLogo;
      }
      if (endpoint === "caha") {
        return CahaLogo;
      }
      if (endpoint === "skiptheq") {
        return SkipTheQLogo;
      }

      if (endpoint === "localpubpassport") {
        return LocalPubPassportLogo;
      }
      if (endpoint === "skiptheqpassport") {
        return SkipTheQPassportLogo;
      }
      if (endpoint === "charliecafe") {
        return CharlieCafeLogo;
      }

      if (store?.image) {
        return store?.image;
      }
      return Logo;
    }
    if (store?.image) {
      return store?.image;
    }
    return Logo;
  }, [isMultiStore, endpoint, store?.image]);

  // const isSpeedBooking = useMemo(
  //   () => typeof location?.pathname === "string" && location.pathname.includes("/speed-booking/"),
  //   [location?.pathname]
  // );

  return (
    <div className="navbar navbar-expand-lg navbar-dark" style={dStyle}>
      <div className="container-fluid">
        {isSpeedBooking ? (
          <div className="navbar-brand" style={{ pointerEvents: "none", cursor: "default" }}>
            <img src={headerImage} alt={endpoint} /><span></span>
          </div>
        ) : (
          <a href="/" className="navbar-brand">
            <img src={headerImage} alt={endpoint} /><span></span>
          </a>
        )}
        {/* <button
        type="button"
        className="navbar-toggler"
        data-toggle="collapse"
        data-target="#navbarCollapse">
        <span className="navbar-toggler-icon"></span>
      </button> */}

        {/* <div
        className="collapse navbar-collapse justify-content-between"
        id="navbarCollapse">
        <div className="navbar-nav ml-auto"> */}
        {/* <a href="/" className="nav-item nav-link">
            Home
          </a>
          <a href="/about" className="nav-item nav-link">
            About
          </a>
          <a href="/service" className="nav-item nav-link">
            Service
          </a>
          <a href="/price" className="nav-item nav-link">
            Price
          </a>
          <a href="/contact" className="nav-item nav-link">
            Contact
          </a> */}
        {/* <a href="/contact" className="nav-item py-2 px-4 ft-black btn btn-primary">Enquire Now</a> */}
        {/* </div>
        
      </div> */}
      </div>
    </div>
  );
};

export default Header;
